// Lista abrangente de marcas de veículos para o Brasil
export const vehicleBrands = [
  // Marcas atuais do sistema
  "Honda",
  "Toyota",
  "Volkswagen",
  "Ford",
  "Chevrolet",
  "Nissan",
  "Hyundai",
  "Fiat",
  "Renault",
  "Peugeot",
  
  // Marcas premium/luxo
  "BMW",
  "Mercedes-Benz",
  "Audi",
  "Volvo",
  "Land Rover",
  "Jaguar",
  "Porsche",
  "Lexus",
  "Infiniti",
  "Maserati",
  "Ferrari",
  "Lamborghini",
  "Bentley",
  "Rolls-Royce",
  "Aston Martin",
  "McLaren",
  
  // Marcas europeias
  "Citroën",
  "DS Automobiles",
  "Alfa Romeo",
  "Mini",
  "Smart",
  "Seat",
  "Skoda",
  "Opel",
  "Lancia",
  "Bugatti",
  
  // Marcas americanas
  "Jeep",
  "Dodge",
  "Chrysler",
  "Cadillac",
  "Lincoln",
  "Buick",
  "GMC",
  "Ram",
  "Tesla",
  "Rivian",
  
  // Marcas asiáticas
  "Mitsubishi",
  "Subaru",
  "Mazda",
  "Suzuki",
  "Isuzu",
  "Kia",
  "SsangYong",
  "Mahindra",
  "Tata",
  
  // Marcas chinesas
  "Chery",
  "JAC",
  "BYD",
  "GWM (Great Wall Motors)",
  "Haval",
  "Changan",
  "Geely",
  "Lifan",
  "BAIC",
  "Dongfeng",
  "FAW",
  "JMC",
  
  // Marcas comerciais/pesados
  "Iveco",
  "Scania",
  "MAN",
  "Mercedes-Benz Caminhões",
  "Volvo Caminhões",
  "Agrale",
  "International",
  "Kenworth",
  "Peterbilt",
  "Mack",
  
  // Marcas de motocicletas (caso necessário)
  "Yamaha",
  "Kawasaki",
  "Harley-Davidson",
  "Ducati",
  "Triumph",
  "Royal Enfield",
  "BMW Motorrad",
  "Honda Motos",
  "Suzuki Motos",
  
  // Outras marcas
  "Caoa Chery",
  "RAM",
  "Foton",
  "Shineray",
  "Effa",
  "Jinbei"
] as const;

export type VehicleBrand = typeof vehicleBrands[number];

// Função para buscar marcas com filtro (para autocomplete)
export const filterBrands = (searchTerm: string): string[] => {
  if (!searchTerm) return [...vehicleBrands];
  
  const term = searchTerm.toLowerCase();
  return vehicleBrands.filter(brand => 
    brand.toLowerCase().includes(term)
  );
};

// Função para verificar se uma marca existe na lista
export const isValidBrand = (brand: string): boolean => {
  return vehicleBrands.includes(brand as VehicleBrand);
};
